import { render, staticRenderFns } from "./MailBatchDialog.vue?vue&type=template&id=68669c6a&scoped=true"
import script from "./MailBatchDialog.vue?vue&type=script&lang=js"
export * from "./MailBatchDialog.vue?vue&type=script&lang=js"
import style0 from "./MailBatchDialog.vue?vue&type=style&index=0&id=68669c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68669c6a",
  null
  
)

export default component.exports